module.exports = __webpack_public_path__ + "static/img/yun01_5.0bda93d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/yun01_5.jpg
// module id = bD5Q
// module chunks = 1